import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator'
import { List } from '@/models/list/list'
import { DeliveryServer } from '@/models/delivery-server/delivery-server'
import { TrackingDomain } from '@/models/tracking-domain/tracking-domain'
import { IMailWizzEntity } from '@/models/common/mailwizz-entity'
import { INamedEntity } from '@/models/common/named-entity'
import { TestCase } from '@/models/test-case/testcase'
import { TESTCASE_SERVICES, TESTCASE_PROVIDERS } from '@/constants/testcase-options'

@Component
export default class PreviewTestcaseComponent extends Vue {

    readonly selectListFormatter = (entity: IMailWizzEntity & INamedEntity) => { return { text: entity.name, value: entity } }

    @Prop() testcase: TestCase
    @Prop() lists: List[]
    @Prop() deliveryServers: DeliveryServer[]
    @Prop() trackingDomains: TrackingDomain[]
    @Prop() invalidFields: string[]

    @Emit('change')
    notifyTestCaseChange(testCase: TestCase) { }

    readonly services = TESTCASE_SERVICES
    readonly providerOptions = TESTCASE_PROVIDERS

    listNameValidation: { [key: number]: string } = {}
    providersLocked: { [key: number]: boolean } = {}

    get campaigns() { return this.testcase && this.testcase.campaigns ? this.testcase.campaigns : [] }

    @Watch('testcase', { immediate: true })
    onTestCaseChange() {
        // Validate initial list states
        this.campaigns.forEach((campaign, index) => {
            if (campaign.service === 'glock' && campaign.list) {
                const newProviders = this.validateListForCampaign(campaign, index);
                if (newProviders !== null) {
                    const testCase = this.cloneTestCase();
                    testCase.campaigns[index].providers = newProviders;
                    this.notifyTestCaseChange(testCase);
                }
            }
        });
    }

    parseProviderIdsFromListName(listName: string): number[] {
        const match = listName.match(/\[([\d,]+)\]/);
        if (!match) return null;
        
        try {
            return match[1].split(',').map(id => parseInt(id.trim()));
        } catch {
            return null;
        }
    }

    validateProviderIds(ids: number[]): boolean {
        if (!ids) return false;
        return ids.every(id => this.providerOptions.some(option => option.value === id));
    }

    validateListForCampaign(campaign: any, index: number) {
        if (campaign.service === 'glock' && campaign.list) {
            const providerIds = this.parseProviderIdsFromListName(campaign.list.name);
            
            if (!providerIds) {
                this.listNameValidation[index] = 'List name should contain provider IDs in square brackets (e.g. [3,17])';
                this.providersLocked[index] = false;
            } else if (!this.validateProviderIds(providerIds)) {
                this.listNameValidation[index] = 'List contains invalid provider IDs';
                this.providersLocked[index] = false;
            } else {
                this.listNameValidation[index] = null;
                this.providersLocked[index] = true;
                return providerIds;
            }
        } else {
            this.listNameValidation[index] = null;
            this.providersLocked[index] = false;
        }
        return null;
    }

    notifyFieldChanged(field: string, index: number, value: any) {
        const testCase = this.cloneTestCase()
        testCase.campaigns[index][field] = value
        
        // If list was changed, validate it
        if (field === 'list') {
            const newProviders = this.validateListForCampaign(testCase.campaigns[index], index);
            if (newProviders !== null) {
                testCase.campaigns[index].providers = newProviders;
            }
        }
        
        this.notifyTestCaseChange(testCase)
    }

    deleteCampaign(index: number) {
        const testCase = this.cloneTestCase()
        testCase.campaigns.splice(index, 1)
        this.notifyTestCaseChange(testCase)
    }

    getValidationState(fieldname: string) {
        return this.invalidFields.indexOf(fieldname) >= 0 ? false : null
    }

    cloneTestCase() : TestCase {
        return JSON.parse(JSON.stringify(this.testcase))
    }
}